import GetReferentsRequestModelBase from '../_generated/modelBases/get-referents-request-model-base';

export default class GetReferentsRequestModel extends GetReferentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
